<template>
  <router-view v-if="$root.$data.portalInfo !== null"></router-view>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  @import '@/assets/scss/style';
</style>
